export const TOOLBAR_FIT_STEP = 8

export const TOOLBAR_FIT_MIN_BUCKET = 80

export const TOOLBAR_FIT_MAX_BUCKET = 250

export const TOOLBAR_FIT_MARGIN = 8

const FONTS = {
  regular: {
    widths: [
      267, 305, 335, 545, 545, 773, 814, 218, 280, 280, 351, 505, 225, 360, 214,
      354, 545, 545, 545, 545, 545, 545, 545, 545, 545, 545, 219, 256, 505, 505,
      505, 436, 1064, 585, 584, 571, 654, 536, 517, 612, 672, 291, 291, 610,
      517, 791, 673, 684, 559, 684, 595, 531, 555, 652, 568, 828, 618, 558, 545,
      304, 380, 304, 500, 408, 280, 496, 540, 451, 538, 508, 319, 537, 547, 268,
      267, 479, 292, 812, 547, 536, 541, 537, 340, 421, 339, 539, 482, 735, 515,
      466, 447, 346, 238, 346, 505,
    ],
    extra: {
      '«': 478,
      '»': 478,
      '–': 660,
      '—': 820,
      '“': 340,
      '”': 340,
      '„': 340,
      '‘': 194,
      '’': 194,
      '·': 267,
      '×': 505,
      '°': 425,
      '…': 759,
      '\u00a0': 267,
      '\u202f': 134,
      ß: 592,
      æ: 796,
      ø: 536,
      œ: 858,
      '≥': 838,
      '≤': 838,
    },
    fallback: [610, 690],
  },
  bold: {
    widths: [
      253, 294, 402, 567, 567, 840, 814, 254, 327, 327, 378, 527, 252, 360, 246,
      408, 567, 567, 567, 567, 567, 567, 567, 567, 567, 567, 269, 290, 527, 527,
      527, 454, 1059, 605, 591, 559, 647, 522, 508, 609, 651, 285, 334, 620,
      514, 800, 657, 670, 572, 670, 602, 530, 568, 627, 602, 862, 633, 592, 539,
      324, 424, 324, 500, 444, 316, 496, 536, 433, 539, 508, 321, 536, 545, 269,
      268, 491, 294, 805, 545, 537, 540, 536, 351, 422, 349, 538, 477, 721, 525,
      478, 458, 371, 227, 371, 527,
    ],
    extra: {
      '«': 488,
      '»': 488,
      '–': 660,
      '—': 820,
      '“': 396,
      '”': 396,
      '„': 396,
      '‘': 223,
      '’': 223,
      '·': 253,
      '×': 527,
      '°': 437,
      '…': 809,
      '\u00a0': 253,
      '\u202f': 127,
      ß: 630,
      æ: 785,
      ø: 536,
      œ: 841,
      '≥': 838,
      '≤': 838,
    },
    fallback: [680, 760],
  },
  cockpit: {
    widths: [
      200, 269, 306, 606, 434, 772, 581, 152, 279, 279, 361, 439, 199, 325, 211,
      386, 475, 475, 475, 475, 475, 475, 475, 475, 475, 475, 252, 218, 439, 439,
      439, 413, 759, 456, 462, 457, 472, 435, 415, 462, 477, 224, 443, 477, 415,
      538, 507, 467, 457, 455, 461, 434, 452, 478, 471, 665, 460, 456, 406, 330,
      386, 330, 413, 405, 206, 434, 437, 422, 437, 426, 291, 431, 439, 215, 211,
      433, 199, 665, 439, 432, 441, 441, 313, 398, 282, 438, 415, 592, 417, 403,
      368, 319, 171, 319, 480,
    ],
    extra: {
      '«': 463,
      '»': 463,
      '–': 377,
      '—': 593,
      '“': 316,
      '”': 316,
      '„': 309,
      '‘': 165,
      '’': 165,
      '·': 215,
      '×': 389,
      '°': 359,
      '…': 679,
      '\u00a0': 200,
      '\u202f': 100,
      ß: 450,
      æ: 674,
      ø: 462,
      œ: 679,
      '≥': 838,
      '≤': 838,
    },
    fallback: [680, 760],
  },
}

const FALLBACK_SCALE = 1.2

const WIDE_GLYPHS_FROM = 0x2e80

const LABEL = { font: 'bold', size: 15 }
const NAME = { font: 'regular', size: 15 }
const VALUE = { font: 'cockpit', size: 18, spacing: 0.54 }
const TOTAL = { font: 'cockpit', size: 20, spacing: 1, upper: true }
const NUMBER = { font: 'cockpit', size: 24, spacing: 0.48 }
const CONTEXT = { font: 'regular', size: 13, spacing: 0.32 }
const CONTEXT_NAME = { font: 'bold', size: 13, spacing: 0.32 }
const BADGE = { font: 'bold', size: 13 }

const GAP = 8
const COUNT_MAX = 300
const COUNT_WIDE = 520
const COUNT_INSET = 15
const COUNT_MARGIN = 8
const CANCEL = 34
const CHIP_PADDING = 32
const ICON_CHIP_PADDING = 28
const ACTIVE_PADDING = 24
const STATIC_PADDING = 26
const ICON = 18
const CHEVRON = 12
const REMOVE = 44
const BADGE_MIN = 22
const BADGE_PADDING = 12
const DIVIDER = 17
const CLEAR_TEXT_PADDING = 12
const ERASER = 44
const TOOLS_GAP = 10
const TOGGLE = 96

function glyphWidth(char, font) {
  const code = char.codePointAt(0)
  if (code >= 32 && code < 127) return font.widths[code - 32]
  if (font.extra[char]) return font.extra[char]
  if (code >= WIDE_GLYPHS_FROM) return 1000

  const base = char.normalize('NFD').codePointAt(0)
  if (base >= 32 && base < 127) {
    return font.widths[base - 32] * (code > 0xff ? FALLBACK_SCALE : 1)
  }

  return char === char.toLowerCase() ? font.fallback[0] : font.fallback[1]
}

export function toolbarTextWidth(text, style, locale) {
  const font = FONTS[style.font]
  const value = String(text || '')
  const chars = [...(style.upper ? value.toLocaleUpperCase(locale) : value)]
  const em = chars.reduce((sum, char) => sum + glyphWidth(char, font), 0)

  return (em * style.size) / 1000 + (style.spacing || 0) * chars.length
}

function countWidth({ number, text, context, name, cancelable }, max, width) {
  const total = width(number, NUMBER) + width(text, TOTAL)
  const line =
    context || name ? width(context, CONTEXT) + width(name, CONTEXT_NAME) : 0
  const inner = Math.max(total, line) + (cancelable ? CANCEL : 0)

  return Math.min(max, COUNT_INSET + inner) + COUNT_MARGIN
}

function allFiltersWidth({ label, badge }, icon, width) {
  const badgeWidth = badge
    ? GAP + Math.max(BADGE_MIN, BADGE_PADDING + width(badge, BADGE))
    : 0

  return icon
    ? ICON_CHIP_PADDING + ICON + badgeWidth + DIVIDER
    : CHIP_PADDING + ICON + GAP + width(label, LABEL) + badgeWidth + DIVIDER
}

function chipWidth({ name, value, orphan }, showNames, tight, width) {
  if (!value) {
    return CHIP_PADDING + ICON + GAP + width(name, LABEL) + GAP + CHEVRON
  }

  const content =
    ICON + GAP + (showNames ? width(name, NAME) + GAP : 0) + width(value, VALUE)

  return orphan
    ? STATIC_PADDING + content + REMOVE
    : ACTIVE_PADDING + content + (tight ? 0 : GAP + CHEVRON) + REMOVE
}

function sortWidth(sort, { sortShort, sortIcon, tight }, width) {
  if (!sort) return 0

  const label = sortIcon
    ? 0
    : GAP +
      (sortShort ? 0 : width(sort.prefix, NAME)) +
      width(sort.value, LABEL)

  return CHIP_PADDING + ICON + label + (tight ? 0 : GAP + CHEVRON)
}

function toolsWidth(sort, toggle, options, width) {
  const sortPart = sortWidth(sort, options, width)
  const toggleWidth = toggle ? TOGGLE : 0

  return sortPart && toggleWidth
    ? sortPart + TOOLS_GAP + toggleWidth
    : sortPart + toggleWidth
}

function rowWidth(model, options, width) {
  const { countMax, eraser, names, filtersShort, filtersIcon, tight } = options
  const tools = toolsWidth(model.sort, model.toggle, options, width)
  const items = [
    countWidth(model.count, countMax, width),
    allFiltersWidth(
      {
        label: filtersShort ? model.allFilters.short : model.allFilters.full,
        badge: model.allFilters.badge,
      },
      !!filtersIcon,
      width
    ),
    ...model.chips.map(chip => chipWidth(chip, names, !!tight, width)),
    ...(model.clearAll
      ? [eraser ? ERASER : CLEAR_TEXT_PADDING + width(model.clearAll, LABEL)]
      : []),
    ...(tools ? [tools] : []),
  ]

  return items.reduce((sum, item) => sum + item, 0) + GAP * (items.length - 1)
}

export const TOOLBAR_FIT_TIERS = [
  ['wide', { names: true, countMax: COUNT_WIDE }],
  ['full', { countMax: COUNT_MAX }],
  ['eraser', { eraser: true }],
  ['nameless', { names: false }],
  ['sortshort', { sortShort: true }],
  ['short', { filtersShort: true }],
  ['icon', { filtersIcon: true }],
  ['mute', { sortIcon: true }],
  ['tight', { tight: true }],
]

export const TOOLBAR_FIT_TIER_NAMES = TOOLBAR_FIT_TIERS.map(([tier]) => tier)

export function productListToolbarNeeds(model) {
  const width = (text, style) => toolbarTextWidth(text, style, model.locale)
  const needs = {}
  let options = {}

  for (const [tier, step] of TOOLBAR_FIT_TIERS) {
    options = { ...options, ...step }
    needs[tier] = rowWidth(model, options, width)
  }

  return needs
}

export function toolbarFitBucket(width) {
  const bucket = Math.ceil((width + TOOLBAR_FIT_MARGIN) / TOOLBAR_FIT_STEP)

  return Math.min(
    TOOLBAR_FIT_MAX_BUCKET,
    Math.max(TOOLBAR_FIT_MIN_BUCKET, bucket)
  )
}

export function productListToolbarFitClasses(needs) {
  return TOOLBAR_FIT_TIERS.slice(1).map(
    ([tier], index) =>
      `plt--${tier}-${toolbarFitBucket(needs[TOOLBAR_FIT_TIERS[index][0]])}`
  )
}
